import { useQuery } from "react-query";
import { getLeasedEquipmentTypeList } from "../../../../../actions/Utilities/LeasedEquipmentType";

export default function useGetTypeList() {
  return useQuery("GetType", getLeasedEquipmentTypeList, {
    refetchOnWindowFocus: false,
  });
}
